import PropTypes from 'prop-types';

import colors from 'Application/theme/colors';

import CommentList from 'Common/components/Comments/CommentList';
import styled from 'styled-components/macro';
import sizing from 'Application/theme/sizes';
import useProjectDetailsCommentsData from 'PMWorkflow/components/Project/hooks/useProjectCommentsData';

const Comment = styled.div`
	padding-top: ${sizing.spacing(6)};
`;
const CommentLabel = styled.div`
	color: ${colors.text.grey};
	font-size: 14px;
	font-weight: 700;
`;
const CommentContent = styled.div`
	font-size: 16px;
	font-weight: 400;
`;

const ProjectDetailsSidePanelComments = ({ project }) => {
	const { defaultComments, onAddComment, onEditComment, onDeleteComment } =
		useProjectDetailsCommentsData(project);

	return (
		<>
			<CommentList
				defaultComments={defaultComments}
				onAddComment={onAddComment}
				onEditComment={onEditComment}
				onDeleteComment={onDeleteComment}
			/>

			{Boolean(project?.comment) && (
				<Comment>
					<CommentLabel>Comment</CommentLabel>
					<CommentContent>{project?.comment}</CommentContent>
				</Comment>
			)}
		</>
	);
};

ProjectDetailsSidePanelComments.defaultProps = {
	project: {},
};

ProjectDetailsSidePanelComments.propTypes = {
	project: PropTypes.shape({
		comment: PropTypes.string,
	}),
};

export default ProjectDetailsSidePanelComments;
